import {Base} from "@/api/Base"

export class PolicyAdd extends Base {
    path = "policy/add"
}